import React from "react";
import cropr from "../../shared/utils/cropr";
import { gettext, interpolate } from "../../shared/utils/legacy";
import { getIconClass } from "../utils";

const getNegativeStockCount = () => {
  const items = Object.values(cropr.stockPerVariant).map((variant) => variant.items);
  let negativeCnt = 0;
  items.forEach((item) => {
    Object.values(item).forEach((stockVariant) => {
      // NOTE: similar calculation in dashboardTabsTemplate.
      if (stockVariant.quantity - stockVariant.used <= -0.5) negativeCnt += 1;
    });
  });
  return negativeCnt;
};

export default function DashboardSummaryStock() {
  // - Je hebt negatieve voorraad
  // - Klik: in schuur direct visueel hebben waar je negatieve voorraad hebt.
  const negativeStockCount = getNegativeStockCount();
  const statusBoolean = negativeStockCount === 0;
  return (
    cropr.permissions.barn.read && (
      <div className="col-4 col-md py-3">
        <h6 className="text-muted mb-3">{gettext("Stock")}</h6>
        <a
          href={'/cropr/dashboard/#fertilizer/{"showNegativeCnt": true}'}
          title={gettext("Go to stock overview")}
          className="text-black"
          data-metrics_category="summary_widget"
          data-metrics_sub_category="stock"
        >
          <i className={getIconClass(statusBoolean)} />
          &nbsp;
          {negativeStockCount === 1
            ? interpolate(gettext("%s product out of stock"), [negativeStockCount])
            : interpolate(gettext("%s products out of stock"), [negativeStockCount])}
        </a>
      </div>
    )
  );
}
